import Moment from "moment";

export const formatDate = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "-";
  }
  Moment.locale(local ?? "en");
  return Moment(date).format("MM/DD/YYYY");
};

export const formatDateTask = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "";
  }
  Moment.locale(local ?? "en");

  // Parse the date in UTC mode to avoid timezone adjustments
  return Moment.utc(date).format("MM/DD/YYYY");
};



export const formatDateLong = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "";
  }
  Moment.locale(local ?? "en");
  return Moment(date).format("dddd, MMMM DD, YYYY");
};

export const formatDateLongWithSuffix = (
  date: Date | string | undefined | null,
  local?: string
 ) => {
  if (!date) {
    return "";
  }
  Moment.locale(local ?? "en");
  const dayOfMonth = Moment(date).date();
  const suffix = getDaySuffix(dayOfMonth);
  return Moment(date).format(`dddd, MMMM D`) + suffix +", "+ Moment(date).format(`YYYY`);
};

const getDaySuffix = (day: number) => {
  if (day % 10 === 1 && day % 100 !== 11) {
    return "st";
  } else if (day % 10 === 2 && day % 100 !== 12) {
    return "nd";
  } else if (day % 10 === 3 && day % 100 !== 13) {
    return "rd";
  } else {
    return "th";
  }
};




export const formatDateTime = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "-";
  }
  Moment.locale(local ?? "en");
  return Moment(date).format("MM/DD/YYYY hh:mm A");
};

export const formatDateTimeShort = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "-";
  }
  Moment.locale(local ?? "en");
  return Moment(date).format("MMM DD, YYYY hh:mm A");
};

export const formatTime = (
  date: Date | string | undefined | null,
  local?: string
) => {
  if (!date) {
    return "-";
  }
  Moment.locale(local ?? "en");
  return Moment(date).format("hh:mm A");
};


export const getAge = (dob?: Date) => {
  if (!dob || !(dob instanceof Date) || isNaN(dob.getTime())) {
    if(dob == undefined)
      return "-";
    else
      dob = new Date(dob);
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDifference = today.getMonth() - dob.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age + " Years";
};

export const formatPassTime = (date: Date) => {
  if (!date) {
    return "";
  }
  
  let millis: number = Date.now() - new Date(date).getTime();
  
  const parts: string[] = [];

  const years = Math.floor(millis / (365.25 * 24 * 60 * 60 * 1000));
  millis -= years * (365.25 * 24 * 60 * 60 * 1000);
  if (years > 0) {
    parts.push(years + " year" + (years > 1 ? "s" : ""));
  }

  const months = Math.floor(millis / (30.44 * 24 * 60 * 60 * 1000)); // Average month length (30.44 days)
  millis -= months * (30.44 * 24 * 60 * 60 * 1000);
  if (months > 0) {
    parts.push(months + " month" + (months > 1 ? "s" : ""));
  }

  const days = Math.floor(millis / (24 * 60 * 60 * 1000));
  millis -= days * (24 * 60 * 60 * 1000);
  if (days > 0) {
    parts.push(days + " day" + (days > 1 ? "s" : ""));
  }

  const hours = Math.floor(millis / (60 * 60 * 1000));
  millis -= hours * (60 * 60 * 1000);
  if (hours > 0) {
    parts.push(hours + " hour" + (hours > 1 ? "s" : ""));
  }

  const minutes = Math.floor(millis / (60 * 1000));
  if (minutes > 0) {
    parts.push(minutes + " minute" + (minutes > 1 ? "s" : ""));
  }

  return parts.join(" ");
}

export const formatTimeToHHMM = (date: Date): string => {
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDateToMMDDYYYY = (date: Date): string => {
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date);
};

export const roundToNearest15Minutes = () => {
  const now = new Date();
  const minutes = now.getMinutes();
  const roundedMinutes = Math.round(minutes / 15) * 15;
  now.setMinutes(roundedMinutes);
  now.setSeconds(0);
  now.setMilliseconds(0);
  return now;
}
